import React, {Component} from 'react';
import PrintTwoPagesDoc from './PrintTwoPagesDoc';

class PrintTwoPagesTaxInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintTwoPagesDoc
        title={'ใบเสร็จรับเงิน/ใบกำกับภาษี'} 
        doc={'taxinvoice_doc'}
        docNo={this.props.tivNo}
        param={'tiv'}
      >
      </PrintTwoPagesDoc>
    )
  }
}  

export default PrintTwoPagesTaxInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesTaxInvoiceDoc.js